import React, { useState } from "react";
import styles from './Home.module.scss';
import PageTitle from "../../../components/pageTitle/PageTitle";
import Dropdown from "../../../components/dropdown/Dropdown";
import SummaryView from "./SummaryView";
import GraduationSummaryView from "./GraduationSummaryView";

const Home = () => {
  const [selectedFilter, setSelectedFilter] = useState('summary');

  return (
    <>
      <div className={styles.header}>
        <PageTitle
          label="Home"
        />
        <div className={styles.dropdown}>
          <Dropdown
            options={[
              { label: 'Summary', value: 'summary' },
              { label: 'Graduation Summary', value: 'graduationSummary' },
            ]}
            value={selectedFilter}
            onChange={setSelectedFilter}
            size="small"
          />
        </div>
      </div>
      <div className={styles.container}>
        {selectedFilter === 'summary' && <SummaryView />}
        {selectedFilter === 'graduationSummary' && <GraduationSummaryView />}
      </div>
    </>
  );
};

export default Home;